import { render, staticRenderFns } from "./regulManagerTab.vue?vue&type=template&id=84090934"
import script from "./regulManagerTab.vue?vue&type=script&lang=js"
export * from "./regulManagerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84090934')) {
      api.createRecord('84090934', component.options)
    } else {
      api.reload('84090934', component.options)
    }
    module.hot.accept("./regulManagerTab.vue?vue&type=template&id=84090934", function () {
      api.rerender('84090934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/mail/regulManagerTab.vue"
export default component.exports